import {
    Grid,
    Paper,
    Typography,
  } from '@material-ui/core';
  import React from 'react';
  
  
  const AdyenPaymentSettings: React.FC = () => {
    
    return (
      <Paper style={{ paddingBottom: '30px' }}>
        <Grid container spacing={2}>
          <Grid item xs={3} />
          <Grid container xs={6} spacing={2} style={{ minHeight: '72vh', alignContent: 'flex-start' }}>
            <Grid item xs={12} style={{ paddingTop: '30px', textAlign: 'center' }}>
              <Typography variant="h4">Target Pay is successfully configured</Typography>
            </Grid>
          </Grid>
        
        </Grid>
      </Paper>
    );
  };
  
  export default AdyenPaymentSettings;
  